export default "__VITE_ASSET__AfKVDumg__"